// delta2-03 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "% no app": "% en la aplicación",
    "%{arg1} clientes selecionados": "%{arg1} clientes seleccionados",
    "%{arg1} cobranças": "%{arg1} cobros",
    "%{arg1} em aberto": "%{arg1} pendientes",
    "%{arg1} em atraso": "%{arg1} atrasadas",
    "%{arg1} implantação": "%{arg1} implementación",
    "%{arg1} pagas": "%{arg1} pagadas",
    "%{arg1} · %{arg2} no app": "%{arg1} · %{arg2} en la aplicación",
    "%{arg1}, %{arg2}, %{arg3} - %{arg4}": "%{arg1}, %{arg2}, %{arg3} - %{arg4}",
    ".csv": ".csv",
    ".gif": ".gif",
    ".jpeg": ".jpeg",
    ".jpg": ".jpg",
    ".png": ".png",
    ".webp": ".webp",
    ".xls": ".xls",
    ".xlsx": ".xlsx",
    "0 1px 4px rgba(0,0,0,0.25)": "0 1px 4px rgba(0,0,0,0.25)",
    "0 20px 0 0": "0 20px 0 0",
    "1 1 480px": "1 1 480px",
    "1 resgate por cliente (fixo)": "1 canje por cliente (fijo)",
    "1.5em": "1.5em",
    "10px 0": "10px 0",
    "1px dashed rgba(0,0,0,0.08)": "1px dashed rgba(0,0,0,0.08)",
    "1px solid #e2e8f0": "1px solid #e2e8f0",
    "1px solid #e5e7eb": "1px solid #e5e7eb",
    "1px solid rgba(102, 126, 234, 0.3)": "1px solid rgba(102, 126, 234, 0.3)",
    "260px": "260px",
    "312px": "312px",
    "3px solid #fff": "3px solid #fff",
    "65vh": "65vh",
    "A data de início não muda depois que a roleta é ativada.": "La fecha de inicio no cambia después de que se activa la ruleta.",
    "A mensalidade é gerada pela assinatura do ERP, que carimba a competência com a data em que o boleto é emitido.": "La mensualidad es generada por la suscripción del ERP, que marca el mes de facturación con la fecha en que se emite el boleto.",
    "A mensalidade é gerada todo dia 1º pelo nosso worker, com a competência do mês de referência.": "La mensualidad es generada el día 1 de cada mes por nuestro worker, con el mes de facturación del mes de referencia.",
    "Assinatura do Gestão Click": "Suscripción de Gestão Click",
    "Ative para definir uma frequência de disponibilidade (diária ou semanal)": "Active para definir una frecuencia de disponibilidad (diaria o semanal)",
    "Baixa em depósito": "Baja en depósito",
    "Baixa em mostruário": "Baja en muestrario",
    "Brindes com regra de Divulgação não se repetem (1 resgate por cliente). A frequência fica fixa em \"não se repete\" — controle a vigência pelas datas de início e término.": "Los premios con regla de Divulgación no se repiten (1 canje por cliente). La frecuencia queda fija en \"no se repite\" — controle la vigencia por las fechas de inicio y término.",
    "Brindes vinculados a um bolão não se repetem (1 ticket/prêmio por cliente por bolão). A vigência casa com o prazo de palpite e o processamento do bolão — não há frequência configurável.": "Los premios vinculados a una quiniela no se repiten (1 ticket/premio por cliente por quiniela). La vigencia coincide con el plazo de pronóstico y el procesamiento de la quiniela — no hay frecuencia configurable.",
    "Cada giro vale até o fim da roleta": "Cada giro vale hasta el fin de la ruleta",
    "Como funcionam as Compras Acumuladas?": "¿Cómo funcionan las Compras Acumuladas?",
    "Configuração de Compra": "Configuración de Compra",
    "Configuração de Compras Acumuladas": "Configuración de Compras Acumuladas",
    "Confirmar Pagamento": "Confirmar Pago",
    "Códigos do PDV — identificados direto na venda": "Códigos del PDV — identificados directo en la venta",
    "DESC": "DESC",
    "Definir área no mapa": "Definir área en el mapa",
    "Deve ser no mínimo 1": "Debe ser como mínimo 1",
    "Deve ser no mínimo R$ 0.01": "Debe ser como mínimo R$ 0.01",
    "Devolver à assinatura do ERP": "Devolver a la suscripción del ERP",
    "Editar área no mapa": "Editar área en el mapa",
    "Encerrar roleta": "Finalizar ruleta",
    "Entrada em depósito": "Entrada en depósito",
    "Entrada em mostruário": "Entrada en muestrario",
    "Enviando...": "Enviando...",
    "Erro ao %{arg1} posto": "Error al %{arg1} estación",
    "Frequência desabilitada para este tipo de brinde": "Frecuencia deshabilitada para este tipo de premio",
    "Ganhe desconto ao abastecer! Use o meu código referral_code e ganhe ainda mais pontos ao utilizar o app. Garanta a qualidade e quantidade do combustível e troque pontos por produtos e serviços.": "¡Gane descuento al cargar combustible! Use mi código referral_code y gane aún más puntos al utilizar la aplicación. Garantice la calidad y cantidad del combustible y canjee puntos por productos y servicios.",
    "Gerado pela PontuaX": "Generado por PontuaX",
    "Gerar no Gestão Click": "Generar en Gestão Click",
    "Girando…": "Girando…",
    "ID %{arg1}": "ID %{arg1}",
    "Imediatamente": "Inmediatamente",
    "Inativar roleta": "Inactivar ruleta",
    "Intervalo em dias para verificação no Clube Certo": "Intervalo en días para verificación en el Club Certo",
    "Ligar faturamento pela PontuaX": "Activar facturación por PontuaX",
    "Limpe os produtos de venda para usar este campo": "Limpie los productos de venta para usar este campo",
    "Limpe os produtos do catálogo para usar este campo": "Limpie los productos del catálogo para usar este campo",
    "Litros Min.": "Litros Mín.",
    "Litros Máx.": "Litros Máx.",
    "Nenhum posto encontrado": "Ninguna estación encontrada",
    "Nenhum posto ou parceiro encontrado": "Ninguna estación o socio comercial encontrada",
    "O cliente ganha o brinde quando confirma o cadastro no aplicativo.": "El cliente gana el premio cuando confirma el registro en la aplicación.",
    "O cliente ganha o brinde quando termina de preencher os dados do perfil no aplicativo.": "El cliente gana el premio cuando termina de completar los datos del perfil en la aplicación.",
    "Permitido imagens de até %{arg1}": "Se permiten imágenes de hasta %{arg1}",
    "Período inclui envios antigos calculados de outra forma (antes de jun/2026) — os totais continuam corretos, só a origem do cálculo muda.": "El período incluye envíos antiguos calculados de otra forma (antes de jun/2026) — los totales siguen siendo correctos, solo cambia el origen del cálculo.",
    "Posto %{arg1} com sucesso": "Estación %{arg1} con éxito",
    "Posto sem mensalidade no cadastro": "Estación sin mensualidad en el registro",
    "Posto sem valor de instalação no cadastro": "Estación sin valor de instalación en el registro",
    "Postos e parceiros": "Estaciones y socios comerciales",
    "Precisará abastecer X vezes": "Deberá cargar combustible X veces",
    "Precisará comprar X vezes": "Deberá comprar X veces",
    "Processando...": "Procesando...",
    "Produto #%{arg1}": "Producto #%{arg1}",
    "Quantos pontos o cliente paga a cada troca. Número inteiro.": "Cuántos puntos paga el cliente en cada canje. Número entero.",
    "Recompensa Direito ao Palpite não gera cupom resgatável em posto — o cliente recebe um ticket de palpite no bolão vinculado. Prossiga para o próximo passo.": "La recompensa Derecho al Pronóstico no genera un cupón canjeable en la estación — el cliente recibe un ticket de pronóstico en la quiniela vinculada. Continúe con el próximo paso.",
    "Recompensa Número da Sorte não gera cupom resgatável em posto — o cliente recebe os números do sorteio vinculado. Prossiga para o próximo passo.": "La recompensa Número de la Suerte no genera un cupón canjeable en la estación — el cliente recibe los números del sorteo vinculado. Continúe con el próximo paso.",
    "Restante máx.": "Restante máx.",
    "Restante mín.": "Restante mín.",
    "Selecione os postos onde esta regra se aplica": "Seleccione las estaciones donde esta regla se aplica",
    "Selecione os postos ou parceiros onde a compra vale": "Seleccione las estaciones o socios comerciales donde la compra es válida",
    "Soma total das compras em reais": "Suma total de las compras en reales",
    "Soma total em litros": "Suma total en litros",
    "Soma total em reais": "Suma total en reales",
    "Sua rede: %{arg1}": "Su red: %{arg1}",
    "Só aparecem habilitados os produtos com combo cadastrado": "Solo aparecen habilitados los productos con combo registrado",
    "Taxa de leitura": "Tasa de lectura",
    "Tempo real": "Tiempo real",
    "Testar giro": "Probar giro",
    "Valor Acumulado": "Valor Acumulado",
    "Valor Mínimo da Compra": "Valor Mínimo de la Compra",
    "Valor mínimo da compra, somando só os produtos": "Valor mínimo de la compra, sumando solo los productos",
    "Valor mínimo em reais": "Valor mínimo en reales",
    "Valor que o cliente pagará via Pix": "Valor que el cliente pagará vía Pix",
    "Vigência pela agenda (início/fim)": "Vigencia por la agenda (inicio/fin)",
    "Volume mínimo em litros": "Volumen mínimo en litros",
    "[Sem cupom/série]": "[Sin cupón/serie]",
    "action.hover": "action.hover",
    "black": "black",
    "compre R$ 30,00 ou mais na conveniência e ganhe R$ 0,10 de desconto por litro.": "compre R$ 30,00 o más en la tienda de conveniencia y gane R$ 0,10 de descuento por litro.",
    "dia": "día",
    "gaste R$ 100,00 na conveniência ao longo do mês e ganhe o brinde.": "gaste R$ 100,00 en la tienda de conveniencia a lo largo del mes y gane el premio.",
    "grey.100": "grey.100",
    "grey.300": "grey.300",
    "max-width 0.2s ease, opacity 0.2s ease, margin-left 0.2s ease": "max-width 0.2s ease, opacity 0.2s ease, margin-left 0.2s ease",
    "nope": "nope",
    "numeric": "numeric",
    "ponto": "punto",
    "price": "price",
    "restam %{arg1}": "quedan %{arg1}",
    "rgba(255,255,255,0.08)": "rgba(255,255,255,0.08)",
    "rgba(255,255,255,0.4)": "rgba(255,255,255,0.4)",
    "rgba(255,255,255,0.95)": "rgba(255,255,255,0.95)",
    "s/n": "s/n",
    "screen": "screen",
    "success.light": "success.light",
    "translateX(-50%)": "translateX(-50%)",
    "uma fatia": "una porción",
    "volume": "volumen",
    "webview": "webview",
    "whatsapp": "whatsapp",
    "ℹ️ Regra Exclusiva: Clube Certo": "ℹ️ Regla Exclusiva: Club Certo",
    "⚠️ Configurações do Clube Certo Não Preenchidas": "⚠️ Configuraciones del Club Certo No Completadas",
    "⚠️ R$ 0,00 = vale qualquer compra dos produtos selecionados": "⚠️ R$ 0,00 = vale cualquier compra de los productos seleccionados",
    "⚽ Brinde de Bolão — sem frequência": "⚽ Premio de Quiniela — sin frecuencia",
    "🎟️ Brinde de Divulgação — sem frequência": "🎟️ Premio de Divulgación — sin frecuencia",
    "🎟️ Divulgação — Ferramenta de Atribuição": "🎟️ Divulgación — Herramienta de Atribución",
    "🎟️ Troca por Pontos — o Cliente Compra a Recompensa": "🎟️ Canje por Puntos — el Cliente Compra la Recompensa",
    "💳 Pagamento por Pix - Venda de Descontos": "💳 Pago por Pix - Venta de Descuentos",
};

export default catalogo;
